export const cloudAccountDetailsModalStyles = {
  container: { pt: 2, width: 320 },
};
